module.exports = __webpack_public_path__ + "img/navbar-toggler-icon.8cf0d8e7.svg";